import { Component, EventEmitter, Output } from '@angular/core';
import { SessionService } from '@app/session/session.service';
import { AuthenticateService } from '@app/origami-api/services/authenticate/authenticate.service';
import { finalize } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'ti-provide-password',
  templateUrl: 'provide-password.component.html',
  styleUrls: ['provide-password.component.sass'],
})
export class ProvidePasswordComponent {
  @Output() confirmPassword = new EventEmitter<boolean>();
  @Output() close = new EventEmitter();

  strings = tiStrings.tiComponents.groupsAndUsers.userPreferences.providePassword;
  miscStrings = tiStrings.app.misc;

  firstSubmit = true;

  constructor(
    private sessionService: SessionService,
    private authenticateService: AuthenticateService,
  ) {}

  checkPassword(password: string) {
    if (this.firstSubmit) {
      this.firstSubmit = false;
    }

    if (!password) {
      return;
    }

    this.authenticateService
      .verifyLoginPassword({
        password: password,
        login: this.sessionService.user.details.UserName,
      })
      .pipe(finalize(() => this.onClose()))
      .subscribe(
        (res) => {
          if (res.ErrorCode === 0) {
            this.confirmPassword.emit(true);
          }
        },
        (err) => {
          this.confirmPassword.emit(false);
        },
      );
  }

  onClose() {
    this.close.emit();
  }
}
